import React from "react";
import { useSearchParams } from "react-router-dom";
import { CalendarDays, DollarSign } from "lucide-react";
import { MaskLines, Reveal } from "@/components/motion";
import { SectionLabel } from "@/components/shared";
import { RegistrationForm } from "@/components/RegistrationForm";
import { AGE_GROUPS, SESSION_INFO } from "@/data/site";

export default function Register() {
  const [params] = useSearchParams();
  const group = params.get("group") || "";
  const valid = AGE_GROUPS.some((g) => g.id === group) ? group : "";

  return (
    <div data-testid="register-page">
      <section className="relative overflow-hidden pb-10 pt-40 md:pt-48">
        <div className="mx-auto max-w-[1400px] px-5 md:px-10">
          <SectionLabel>Sign Up For Training</SectionLabel>
          <h1 className="font-heading text-6xl uppercase leading-[0.82] tracking-tight text-white sm:text-8xl lg:text-[8rem]">
            <MaskLines lines={["Claim Your", <span className="text-neon-green">Spot</span>]} />
          </h1>
          <Reveal delay={0.6}>
            <p className="mt-8 max-w-2xl font-body text-lg leading-relaxed text-white/70">
              Fill out the details below to reserve your player's place in the session below. All age groups welcome.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="relative z-10 bg-obsidian pb-28">
        <div className="mx-auto max-w-2xl px-5 md:px-10">
          <Reveal>
            <div data-testid="session-info" className="mb-6 border border-neon-green/40 bg-zinc-900 p-6 sm:p-8">
              <div className="flex items-center gap-2 font-body text-xs font-bold uppercase tracking-[0.3em] text-neon-green">
                <CalendarDays size={16} strokeWidth={2.5} /> {SESSION_INFO.name}
              </div>
              <h3 className="mt-3 font-heading text-2xl uppercase text-white sm:text-3xl">{SESSION_INFO.start}</h3>
              <p className="mt-1 font-body text-sm text-white/70">{SESSION_INFO.cadence} · All age groups (7–9, 10–12, 13–15)</p>
              <div className="mt-5 flex flex-wrap gap-2">
                {SESSION_INFO.dates.map((d) => (
                  <span key={d} className="border border-white/15 bg-obsidian px-3 py-1.5 font-body text-xs font-bold uppercase tracking-wide text-white/80">
                    {d}
                  </span>
                ))}
              </div>
              <div className="mt-5 flex items-center gap-2 border-t border-white/10 pt-5 font-heading text-xl uppercase text-neon-green">
                <DollarSign size={18} strokeWidth={2.5} /> {SESSION_INFO.price}
              </div>
              <p className="mt-2 font-body text-xs text-white/50">+ $5 online payment fee at checkout</p>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="border border-white/10 bg-surface p-6 sm:p-10">
              <RegistrationForm defaultGroup={valid} />
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
